module.exports = __webpack_public_path__ + "static/media/favourite-venues-icon.1081dfdf.webp";